import React, { useState } from "react";
import { LogCompensatorytable, LeavesChangeLogTable, HRNotificationLogTable, HODLeavesLogTable, HODCompensatoryLogTable, HODNotificationLogTable, RHLeaveApprovalDelayLogTable, RHOutDutyApprovalDelayLogTable } from "./Requestoutdutytable";



const HRLogRecords = () => {
  const [toggleState, setToggleState] = useState(1);

  return (
    <>
      <div>
        <div>
          <div className="bloc-tabs-with-white-bg">
            <button
              className={
                toggleState === 1
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(1)}
            >
              Compensatory Logs
            </button>

            <button
              className={
                toggleState === 2
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(2)}
            >
              Leave History Logs
            </button>

            <button
              className={
                toggleState === 3
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(3)}
            >
              Leave Approval Delay Logs
            </button>

            <button
              className={
                toggleState === 4
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(4)}
            >
              OutDuty Approval Delay Logs
            </button>

            {/* <button
              className={
                toggleState === 5
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(5)}
            >
              Notification History Logs
            </button> */}


          </div>
        </div>

        <div className="content-tabs-without-margin">

          {toggleState === 1 ? <LogCompensatorytable /> : null}

          {toggleState === 2 ? <LeavesChangeLogTable /> : null}

          {toggleState === 3 ? <RHLeaveApprovalDelayLogTable /> : null}

          {toggleState === 4 ? <RHOutDutyApprovalDelayLogTable /> : null}

          {toggleState === 5 ? <HRNotificationLogTable /> : null}

        </div>
      </div>
    </>
  );
};

const HODLogRecords = () => {
  const [toggleState, setToggleState] = useState(1);

  return (
    <>
      <div>
        <div>
          <div className="bloc-tabs-with-white-bg">
            <button
              className={
                toggleState === 1
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(1)}
            >
              Department Compensatory Logs
            </button>

            <button
              className={
                toggleState === 2
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(2)}
            >
              Department Leaves History
            </button>

            {/* 
            <button
              className={
                toggleState === 3
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState(3)}
            >
             Department Notification History
            </button> */}


          </div>
        </div>

        <div className="content-tabs-without-margin">

          {toggleState === 1 ? <HODCompensatoryLogTable /> : null}

          {toggleState === 2 ? <HODLeavesLogTable /> : null}

          {toggleState === 3 ? <HODNotificationLogTable /> : null}

        </div>
      </div>
    </>
  );
};


export { HRLogRecords, HODLogRecords };